"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSelectUserPhoneString = exports.makeSelectUserPhoneRegistration = exports.makeSelectUserPhoneFromCookies = exports.makeSelectUserPhone = exports.makeSelectUserNameFromCookies = exports.makeSelectUserName = exports.makeSelectUserHashId = exports.makeSelectUserHasDocument = exports.makeSelectUserFirstName = exports.makeSelectUserEmail = exports.makeSelectUser = exports.makeSelectSubmitAccountRequestStatus = exports.makeSelectSessionId = exports.makeSelectSendAccessCodeRequestStatus = exports.makeSelectRiskAssessmentToken = exports.makeSelectResponse = exports.makeSelectRedirectUrl = exports.makeSelectQuery = exports.makeSelectPinCodeValidationRequestStatus = exports.makeSelectMaskedPhone = exports.makeSelectMaskedEmail = exports.makeSelectLoginProvider = exports.makeSelectJWT = exports.makeSelectIsRequestOngoing = exports.makeSelectIsLogged = exports.makeSelectIdentities = exports.makeSelectFirstVisit = exports.makeSelectFirebaseToken = exports.makeSelectEnableEmailUpdate = exports.makeSelectCountryCode = exports.makeSelectCountry = exports.makeSelectCognitoToken = exports.makeSelectChannel = exports.makeSelectAuthToken = exports.makeSelectAccountForm = void 0;
var _reselect = require("reselect");
var _cookie = require("../utils/cookie");
var _reducer = require("./reducer");
var _isServer = require("../utils/isServer");
var isImmutable = function isImmutable(state) {
  return typeof (state === null || state === void 0 ? void 0 : state.toJS) === "function";
};
var selectAuth = function selectAuth(currentState) {
  var _state$login;
  var state = isImmutable(currentState) ? currentState.toJS() : currentState;
  return (_state$login = state === null || state === void 0 ? void 0 : state.login) !== null && _state$login !== void 0 ? _state$login : _reducer.initialState;
};
var selectUser = function selectUser(state) {
  return selectAuth(state).user;
};
var selectJWT = function selectJWT(state) {
  return selectUser(state).jwt;
};
var makeSelectUser = function makeSelectUser() {
  return (0, _reselect.createSelector)(selectAuth, function (state) {
    return state === null || state === void 0 ? void 0 : state.user;
  });
};
exports.makeSelectUser = makeSelectUser;
var makeSelectResponse = function makeSelectResponse() {
  return (0, _reselect.createSelector)(selectAuth, function (state) {
    return state === null || state === void 0 ? void 0 : state.response;
  });
};
exports.makeSelectResponse = makeSelectResponse;
var makeSelectAccountForm = function makeSelectAccountForm() {
  return (0, _reselect.createSelector)(selectAuth, function (state) {
    return state === null || state === void 0 ? void 0 : state.accountForm;
  });
};
exports.makeSelectAccountForm = makeSelectAccountForm;
var makeSelectSessionId = function makeSelectSessionId() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.sessionId;
  });
};
exports.makeSelectSessionId = makeSelectSessionId;
var makeSelectRiskAssessmentToken = function makeSelectRiskAssessmentToken() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.riskAssessmentToken;
  });
};
exports.makeSelectRiskAssessmentToken = makeSelectRiskAssessmentToken;
var makeSelectFirstVisit = function makeSelectFirstVisit() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.firstVisit;
  });
};
exports.makeSelectFirstVisit = makeSelectFirstVisit;
var makeSelectUserPhoneString = function makeSelectUserPhoneString() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    var _user$phone, _user$phone2, _user$phone3;
    var countryCode = user === null || user === void 0 ? void 0 : (_user$phone = user.phone) === null || _user$phone === void 0 ? void 0 : _user$phone.countryCode;
    var areaCode = user === null || user === void 0 ? void 0 : (_user$phone2 = user.phone) === null || _user$phone2 === void 0 ? void 0 : _user$phone2.areaCode;
    var phoneNumber = user === null || user === void 0 ? void 0 : (_user$phone3 = user.phone) === null || _user$phone3 === void 0 ? void 0 : _user$phone3.phoneNumber;
    return "".concat(countryCode).concat(areaCode).concat(phoneNumber);
  });
};
exports.makeSelectUserPhoneString = makeSelectUserPhoneString;
var makeSelectMaskedEmail = function makeSelectMaskedEmail() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.maskedEmail;
  });
};
exports.makeSelectMaskedEmail = makeSelectMaskedEmail;
var makeSelectUserEmail = function makeSelectUserEmail() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.email;
  });
};
exports.makeSelectUserEmail = makeSelectUserEmail;
var makeSelectEnableEmailUpdate = function makeSelectEnableEmailUpdate() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.enableEmailUpdate;
  });
};
exports.makeSelectEnableEmailUpdate = makeSelectEnableEmailUpdate;
var makeSelectLoginProvider = function makeSelectLoginProvider() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.loginProvider;
  });
};
exports.makeSelectLoginProvider = makeSelectLoginProvider;
var makeSelectChannel = function makeSelectChannel() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.channel;
  });
};
exports.makeSelectChannel = makeSelectChannel;
var makeSelectUserName = function makeSelectUserName() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.name;
  });
};
exports.makeSelectUserName = makeSelectUserName;
var makeSelectUserFirstName = function makeSelectUserFirstName() {
  return (0, _reselect.createSelector)(makeSelectUserName(), function (name) {
    return name ? name.split(" ").shift() : "";
  });
};
exports.makeSelectUserFirstName = makeSelectUserFirstName;
var makeSelectUserPhone = function makeSelectUserPhone() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.phone;
  });
};
exports.makeSelectUserPhone = makeSelectUserPhone;
var makeSelectCountry = function makeSelectCountry() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.country;
  });
};
exports.makeSelectCountry = makeSelectCountry;
var makeSelectCountryCode = function makeSelectCountryCode() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    var _user$phone4;
    return user === null || user === void 0 ? void 0 : (_user$phone4 = user.phone) === null || _user$phone4 === void 0 ? void 0 : _user$phone4.countryCode;
  });
};
exports.makeSelectCountryCode = makeSelectCountryCode;
var makeSelectMaskedPhone = function makeSelectMaskedPhone() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.maskedPhone;
  });
};
exports.makeSelectMaskedPhone = makeSelectMaskedPhone;
var makeSelectUserPhoneRegistration = function makeSelectUserPhoneRegistration() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.isPhoneRegistered;
  });
};
exports.makeSelectUserPhoneRegistration = makeSelectUserPhoneRegistration;
var makeSelectIdentities = function makeSelectIdentities() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.identities;
  });
};
exports.makeSelectIdentities = makeSelectIdentities;
var makeSelectJWT = function makeSelectJWT() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.jwt;
  });
};
exports.makeSelectJWT = makeSelectJWT;
var makeSelectAuthToken = function makeSelectAuthToken() {
  return (0, _reselect.createSelector)(selectJWT, function (jwt) {
    return jwt === null || jwt === void 0 ? void 0 : jwt.app;
  });
};
exports.makeSelectAuthToken = makeSelectAuthToken;
var makeSelectFirebaseToken = function makeSelectFirebaseToken() {
  return (0, _reselect.createSelector)(selectJWT, function (jwt) {
    return jwt === null || jwt === void 0 ? void 0 : jwt.firebase;
  });
};
exports.makeSelectFirebaseToken = makeSelectFirebaseToken;
var makeSelectCognitoToken = function makeSelectCognitoToken() {
  return (0, _reselect.createSelector)(selectJWT, function (jwt) {
    return jwt === null || jwt === void 0 ? void 0 : jwt.cognito;
  });
};
exports.makeSelectCognitoToken = makeSelectCognitoToken;
var makeSelectUserHasDocument = function makeSelectUserHasDocument() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return (user === null || user === void 0 ? void 0 : user.hasDocument) === true;
  });
};
exports.makeSelectUserHasDocument = makeSelectUserHasDocument;
var makeSelectUserHashId = function makeSelectUserHashId() {
  return (0, _reselect.createSelector)(selectUser, function (user) {
    return user === null || user === void 0 ? void 0 : user.hashId;
  });
};
exports.makeSelectUserHashId = makeSelectUserHashId;
var makeSelectIsLogged = function makeSelectIsLogged() {
  return function () {
    if ((0, _isServer.isServer)()) {
      return false;
    }
    return (0, _cookie.hasAuthCookie)();
  };
};
exports.makeSelectIsLogged = makeSelectIsLogged;
var makeSelectUserPhoneFromCookies = function makeSelectUserPhoneFromCookies() {
  if ((0, _isServer.isServer)()) {
    return null;
  }
  var cookieUserData = (0, _cookie.parseCookiesToUser)();
  return cookieUserData ? cookieUserData.telefone : null;
};
exports.makeSelectUserPhoneFromCookies = makeSelectUserPhoneFromCookies;
var makeSelectRedirectUrl = function makeSelectRedirectUrl() {
  return (0, _reselect.createSelector)(selectAuth, function (state) {
    return state === null || state === void 0 ? void 0 : state.redirectUrl;
  });
};
exports.makeSelectRedirectUrl = makeSelectRedirectUrl;
var makeSelectQuery = function makeSelectQuery() {
  return (0, _reselect.createSelector)(selectAuth, function (state) {
    return state === null || state === void 0 ? void 0 : state.query;
  });
};
exports.makeSelectQuery = makeSelectQuery;
var makeSelectUserNameFromCookies = function makeSelectUserNameFromCookies() {
  var defaultUsername = "Usu\xE1rio";
  if ((0, _isServer.isServer)()) {
    return defaultUsername;
  }
  var userData = (0, _cookie.parseCookiesToUser)();
  if (userData) {
    return userData.name;
  }
  return defaultUsername;
};
exports.makeSelectUserNameFromCookies = makeSelectUserNameFromCookies;
var makeSelectIsRequestOngoing = function makeSelectIsRequestOngoing() {
  return (0, _reselect.createSelector)(selectAuth, function (state) {
    return state === null || state === void 0 ? void 0 : state.isRequestOngoing;
  });
};
exports.makeSelectIsRequestOngoing = makeSelectIsRequestOngoing;
var makeSelectSendAccessCodeRequestStatus = function makeSelectSendAccessCodeRequestStatus() {
  return (0, _reselect.createSelector)(selectAuth, function (state) {
    return state === null || state === void 0 ? void 0 : state.request.sendAccessCodeStatus;
  });
};
exports.makeSelectSendAccessCodeRequestStatus = makeSelectSendAccessCodeRequestStatus;
var makeSelectPinCodeValidationRequestStatus = function makeSelectPinCodeValidationRequestStatus() {
  return (0, _reselect.createSelector)(selectAuth, function (state) {
    return state === null || state === void 0 ? void 0 : state.request.pinCodeValidationStatus;
  });
};
exports.makeSelectPinCodeValidationRequestStatus = makeSelectPinCodeValidationRequestStatus;
var makeSelectSubmitAccountRequestStatus = function makeSelectSubmitAccountRequestStatus() {
  return (0, _reselect.createSelector)(selectAuth, function (state) {
    return state === null || state === void 0 ? void 0 : state.request.submitAccountStatus;
  });
};
exports.makeSelectSubmitAccountRequestStatus = makeSelectSubmitAccountRequestStatus;